import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_STATIC_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  USER_DELETED,
  FETCH_ALL_DRIVERS,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED,
} from "../store/types";
import { firebase } from "../config/configureFirebase";
import {
  onValue,
  set,
  push,
  update,
  off,
  get,
  remove,
} from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { signOut } from "firebase/auth";

export const fetchUsers = () => (dispatch) => {
  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null,
  });
  try {
    const { usersRef, driversRef, allLocationsRef, carAddRef } = firebase;
    if (!usersRef && !driversRef) return;

    const handleUsersData = async (data) => {
      let cars = {};
      try {
        if (carAddRef) {
          const carsData = await Promise.race([
            get(carAddRef),
            new Promise((resolve) => setTimeout(() => resolve(null), 3000))
          ]);
          cars = carsData ? carsData.val() || {} : {};
        }
      } catch (carErr) {
        console.warn("[usersactions] Could not load cars (non-blocking):", carErr.message);
      }

      let locations = null;
      try {
        if (allLocationsRef) {
          const locationdata = await Promise.race([
            get(allLocationsRef),
            new Promise((resolve) => setTimeout(() => resolve(null), 3000))
          ]);
          locations = locationdata ? locationdata.val() : null;
        }
      } catch (locErr) {
        console.warn("[usersactions] Could not load locations (non-blocking):", locErr.message);
      }

      const arr = Object.keys(data).map((i) => {
        const user = data[i];
        if (!user || typeof user !== 'object') return null;
        user.id = i;
        user.uid = i;
        user.location = locations && locations[i] ? locations[i] : null;

        const userCars = Object.keys(cars)
          .filter(cid => cars[cid] && (cars[cid].driverId === i || cars[cid].driver === i || cars[cid].driver_uid === i))
          .map(cid => ({ ...cars[cid], id: cid }));

        if (userCars.length > 0) {
          user.cars = userCars.reduce((acc, car) => {
            acc[car.id] = car;
            return acc;
          }, {});

          const active = userCars.find(c => c.isAvailable || c.active) || userCars[0];
          if (active) {
            user.carType = active.carType;
            user.vehicleNumber = active.vehicleNumber;
            user.vehicleMake = active.vehicleMake;
            user.vehicleModel = active.vehicleModel;
            user.car_image = active.car_image;
            user.year = active.year;
            user.color = active.color;
          }
        }
        return user;
      }).filter(Boolean);

      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr,
      });
      dispatch({
        type: FETCH_ALL_DRIVERS_SUCCESS,
        payload: arr.filter(u => u && (u.usertype === 'driver' || u.usertype === 'admin' || u.usertype === 'fleetadmin')),
      });
    };

    if (usersRef) {
      onValue(
        usersRef,
        async (snapshot) => {
          if (snapshot.val()) {
            await handleUsersData(snapshot.val());
          } else {
            dispatch({
              type: FETCH_ALL_USERS_FAILED,
              payload: "No data found.",
            });
          }
        },
        (error) => {
          console.warn("[usersactions] usersRef onValue error, falling back to driversRef:", error.message);
          if (driversRef) {
            onValue(
              driversRef,
              async (snap) => {
                if (snap.val()) {
                  await handleUsersData(snap.val());
                } else {
                  dispatch({
                    type: FETCH_ALL_USERS_FAILED,
                    payload: "No drivers found.",
                  });
                }
              },
              (err) => {
                dispatch({
                  type: FETCH_ALL_USERS_FAILED,
                  payload: err.message,
                });
              }
            );
          } else {
            dispatch({
              type: FETCH_ALL_USERS_FAILED,
              payload: error.message,
            });
          }
        }
      );
    } else if (driversRef) {
      onValue(
        driversRef,
        async (snap) => {
          if (snap.val()) {
            await handleUsersData(snap.val());
          }
        },
        (err) => {
          dispatch({
            type: FETCH_ALL_USERS_FAILED,
            payload: err.message,
          });
        }
      );
    }
  } catch (error) {
    dispatch({
      type: FETCH_ALL_USERS_FAILED,
      payload: error.message,
    });
  }
};

export const fetchUsersOnce = () => async (dispatch) => {
  const { usersRef, driversRef, allLocationsRef, carAddRef } = firebase;

  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null,
  });

  const handleStaticData = async (data) => {
    let cars = {};
    try {
      if (carAddRef) {
        const carsData = await Promise.race([
          get(carAddRef),
          new Promise((resolve) => setTimeout(() => resolve(null), 3000))
        ]);
        cars = carsData ? carsData.val() || {} : {};
      }
    } catch (carErr) {
      console.warn("[usersactions] Could not load cars for fetchUsersOnce (non-blocking):", carErr.message);
    }

    let locations = null;
    try {
      if (allLocationsRef) {
        const locationdata = await Promise.race([
          get(allLocationsRef),
          new Promise((resolve) => setTimeout(() => resolve(null), 3000))
        ]);
        locations = locationdata ? locationdata.val() : null;
      }
    } catch (locErr) {
      console.warn("[usersactions] Could not load locations for fetchUsersOnce (non-blocking):", locErr.message);
    }

    const arr = Object.keys(data).map((i) => {
      const user = data[i];
      user.id = i;
      user.uid = i;
      user.location = locations && locations[i] ? locations[i] : null;

      const userCars = Object.keys(cars)
        .filter(cid => cars[cid] && (cars[cid].driverId === i || cars[cid].driver === i || cars[cid].driver_uid === i))
        .map(cid => ({ ...cars[cid], id: cid }));

      if (userCars.length > 0) {
        user.cars = userCars.reduce((acc, car) => {
          acc[car.id] = car;
          return acc;
        }, {});

        const active = userCars.find(c => c.isAvailable || c.active) || userCars[0];
        if (active) {
          user.carType = active.carType || user.carType;
          user.vehicleNumber = active.vehicleNumber || user.vehicleNumber;
          user.vehicleMake = active.vehicleMake || user.vehicleMake;
          user.vehicleModel = active.vehicleModel || user.vehicleModel;
          user.color = active.color || user.color;
        }
      }
      return user;
    });

    dispatch({
      type: FETCH_ALL_USERS_STATIC_SUCCESS,
      payload: arr,
    });
  };

  try {
    let snapshot = null;
    if (usersRef) {
      try {
        snapshot = await Promise.race([
          get(usersRef),
          new Promise((_, reject) => setTimeout(() => reject(new Error("Timeout usersRef")), 3000))
        ]);
      } catch (err) {
        console.warn("[usersactions] fetchUsersOnce usersRef failed, trying driversRef fallback:", err.message);
      }
    }

    if (!snapshot || !snapshot.val()) {
      if (driversRef) {
        snapshot = await Promise.race([
          get(driversRef),
          new Promise((_, reject) => setTimeout(() => reject(new Error("Timeout driversRef")), 3000))
        ]);
      }
    }

    if (snapshot && snapshot.val()) {
      await handleStaticData(snapshot.val());
    } else {
      dispatch({
        type: FETCH_ALL_USERS_STATIC_FAILED,
        payload: "No users available.",
      });
    }
  } catch (error) {
    console.warn("[usersactions] fetchUsersOnce error:", error.message);
    dispatch({
      type: FETCH_ALL_USERS_STATIC_FAILED,
      payload: error.message,
    });
  }
};
const getRtdbRestBase = () => ((firebase.config && firebase.config.databaseURL) || "https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app").replace(/\/$/, '');

// [ASSIGNABLE_DRIVERS_REST] Authenticated REST read (the mobile SDK session may be unauthenticated -> permission_denied)
const restGet = async (path, query = "", allowUnauthenticated = false) => {
  try {
    const { getValidAuthToken } = require("./authactions");
    const base = getRtdbRestBase();
    let token = await getValidAuthToken();
    if (token) {
      const buildUrl = (tk) => `${base}/${path}.json?auth=${tk}${query ? "&" + query : ""}`;
      let res = await fetch(buildUrl(token));
      if (res.status === 401) {
        token = await getValidAuthToken(true);
        if (token) {
          res = await fetch(buildUrl(token));
        }
      }
      if (res.ok) {
        return await res.json();
      }
    }
    if (allowUnauthenticated) {
      const publicUrl = `${base}/${path}.json${query ? "?" + query : ""}`;
      const pubRes = await fetch(publicUrl);
      if (pubRes.ok) {
        return await pubRes.json();
      }
    }
    return null;
  } catch (e) {
    console.warn(`[usersactions] REST ${path} error:`, e?.message);
    return null;
  }
};

const collectDriverCars = (driverId, driverObj, carsMap) => {
  const fromRoot = Object.values(carsMap || {}).filter(
    (c) => c && (c.driverId === driverId || c.driver === driverId || c.driver_uid === driverId)
  );
  const fromEmbedded =
    driverObj && driverObj.cars && typeof driverObj.cars === "object"
      ? Object.values(driverObj.cars).filter((c) => c && typeof c === "object")
      : [];
  const merged = [...fromRoot];
  for (const emb of fromEmbedded) {
    const isDup = merged.some(
      (m) =>
        (emb.id && m.id && emb.id === m.id) ||
        (emb.carType && m.carType === emb.carType && (emb.vehicleNumber || "") === (m.vehicleNumber || ""))
    );
    if (!isDup) {
      merged.push(emb);
    }
  }
  return merged;
};

const mapAvailableDrivers = (data, allCars, locations, settings) => {
  if (!data || typeof data !== "object") return [];
  const cars = allCars || {};
  const locs = locations || {};
  const sett = settings || {};

  return Object.keys(data)
    .filter((i) => {
      const driverObj = data[i];
      if (!driverObj || typeof driverObj !== "object") return false;
      if (driverObj.usertype && driverObj.usertype !== "driver") return false;
      if (driverObj.accountDeleted === true || driverObj.isDeleted === true || driverObj.isActive === false) return false;

      const driverCars = collectDriverCars(i, driverObj, cars);
      const approvedCars = driverCars.filter(
        (c) =>
          c &&
          (c.approved === true ||
            c.carApproved === true ||
            !sett.carApproval ||
            (driverObj.carApproved === true && c.approved !== false && c.carApproved !== false))
      );
      const hasApprovedCar =
        driverCars.length > 0
          ? approvedCars.length > 0 || Boolean(driverObj.carApproved) || !sett.carApproval || Boolean(driverObj.carType)
          : Boolean(driverObj.carApproved) || !sett.carApproval || Boolean(driverObj.carType);

      const rawLoc =
        locs && locs[i] && locs[i].lat != null && locs[i].lng != null
          ? locs[i]
          : driverObj.location && driverObj.location.lat != null && driverObj.location.lng != null
          ? driverObj.location
          : null;

      const hasValidLoc =
        rawLoc && !isNaN(Number(rawLoc.lat)) && !isNaN(Number(rawLoc.lng));

      const isDriverApproved =
        driverObj.approved === true || sett.driver_approval === false;

      return (
        isDriverApproved &&
        driverObj.driverActiveStatus === true &&
        Boolean(hasValidLoc) &&
        ((driverObj.licenseImage && sett.license_image_required) ||
          !sett.license_image_required) &&
        ((hasApprovedCar && sett.carType_required) ||
          !sett.carType_required) &&
        ((driverObj.term && sett.term_required) || !sett.term_required)
      );
    })
    .map((i) => {
      const driverObj = data[i];
      const driverCars = collectDriverCars(i, driverObj, cars);
      const approvedCars = driverCars.filter(
        (c) =>
          c &&
          (c.approved === true ||
            c.carApproved === true ||
            !sett.carApproval ||
            (driverObj.carApproved === true && c.approved !== false && c.carApproved !== false))
      );
      const carsPool = approvedCars.length > 0 ? approvedCars : driverCars;

      // The active car MUST be determined by the chauffeur:
      // 1. Chauffeur's explicitly selected activeCarId
      // 2. Chauffeur's current carType in driver profile (users/$uid/carType)
      // 3. Car with active === true
      // 4. Fallback: carsPool[0]
      const activeCar =
        (driverObj.activeCarId && carsPool.find((c) => c.id === driverObj.activeCarId)) ||
        (driverObj.carType && carsPool.find((c) => (c.carType || '').trim().toLowerCase() === String(driverObj.carType).trim().toLowerCase())) ||
        carsPool.find((c) => c.active === true && c.active !== false) ||
        carsPool.find(
          (c) =>
            (c.active || c.isAvailable) &&
            c.active !== false &&
            c.isAvailable !== false
        ) || carsPool[0];

      const rawTypes = [
        ...carsPool.map((c) => c && c.carType),
        ...(Array.isArray(driverObj.carTypes) ? driverObj.carTypes : []),
        driverObj.carType,
      ]
        .filter(Boolean)
        .flatMap((t) => (typeof t === "string" ? t.split(",") : [t]))
        .map((t) => (typeof t === "string" ? t.trim() : ""))
        .filter(Boolean);

      const carTypesList = [...new Set(rawTypes)];

      const rawLoc =
        locs && locs[i] && locs[i].lat != null && locs[i].lng != null
          ? locs[i]
          : driverObj.location && driverObj.location.lat != null && driverObj.location.lng != null
          ? driverObj.location
          : null;

      const driverLoc = rawLoc
        ? { lat: Number(rawLoc.lat), lng: Number(rawLoc.lng) }
        : null;

      // The chauffeur's selected carType takes precedence over any root /cars active flag:
      const activeCarType = (
        (typeof driverObj.carType === 'string' && driverObj.carType.trim().length > 0 ? driverObj.carType.split(',')[0] : '') ||
        activeCar?.carType ||
        carTypesList[0] ||
        ""
      ).trim();

      return {
        id: i,
        location: driverLoc,
        carType: activeCarType,
        activeCarId: activeCar?.id || driverObj.activeCarId || null,
        carTypes: carTypesList,
        vehicleNumber: activeCar?.vehicleNumber || driverObj.vehicleNumber || "",
        vehicleMake: activeCar?.vehicleMake || driverObj.vehicleMake || "",
        vehicleModel: activeCar?.vehicleModel || driverObj.vehicleModel || "",
        fleetadmin: driverObj.fleetadmin ? driverObj.fleetadmin : null,
        firstName: driverObj.firstName,
        lastName: driverObj.lastName,
        queue: Boolean(driverObj.queue),
      };
    });
};

export const clearFetchDrivers = () => (dispatch) => {
  const { driversRef, allLocationsRef } = firebase;
  if (!driversRef) return;
  try {
    off(driversRef);
  } catch (_) {}
  try {
    if (allLocationsRef) off(allLocationsRef);
  } catch (_) {}
};

export const fetchDrivers = (appType) => async (dispatch) => {
  const { driversRef, allLocationsRef, settingsRef } = firebase;
  if (!driversRef || !settingsRef) {
    console.warn("[usersactions] firebase reference missing for fetchDrivers");
    return;
  }

  // [LEAK_PREVENTION] Nettoyer tout écouteur existant pour éviter les empilements
  try {
    off(driversRef);
  } catch (_) {}
  try {
    if (allLocationsRef) off(allLocationsRef);
  } catch (_) {}

  // Mode mobile 'app' : lecture ponctuelle atomique avec repli REST automatique si la session JS SDK n'est pas authentifiée
  if (appType === "app") {
    try {
      const hasSdkAuth = Boolean(firebase.auth && firebase.auth.currentUser);
      const safeSdkGet = (refObj, ms = 3500) => {
        if (!refObj) return Promise.resolve(null);
        return Promise.race([
          get(refObj).catch(() => null),
          new Promise((resolve) => setTimeout(() => resolve(null), ms)),
        ]);
      };

      const [settingsSnap, driversSnap, carsSnap, locSnap] = await Promise.all([
        safeSdkGet(settingsRef),
        safeSdkGet(driversRef),
        safeSdkGet(firebase.carAddRef),
        allLocationsRef ? safeSdkGet(allLocationsRef) : Promise.resolve(null),
      ]);

      let settings = (settingsSnap && settingsSnap.val()) || null;
      let driversData = (driversSnap && driversSnap.val()) || null;
      let allCars = (carsSnap && carsSnap.val()) || null;
      let locations = (locSnap && locSnap.val()) || null;

      // Repli REST authentifié pour toute ressource bloquée par les règles RTDB (cars, locations, etc.)
      const driverQuery = `orderBy=${encodeURIComponent('"usertype"')}&equalTo=${encodeURIComponent('"driver"')}`;
      const [restSettings, restDrivers, restCars, restLocations] = await Promise.all([
        !settings ? restGet("settings", "", true) : Promise.resolve(null),
        !driversData ? restGet("users", driverQuery, true) : Promise.resolve(null),
        !allCars || Object.keys(allCars).length === 0 ? restGet("cars", "", true) : Promise.resolve(null),
        !locations || Object.keys(locations).length === 0 ? restGet("locations", "", true) : Promise.resolve(null),
      ]);

      if (!settings) {
        settings = restSettings || store.getState()?.settingsdata?.settings || {};
      }
      if (!driversData && restDrivers) {
        driversData = restDrivers;
      }
      if ((!allCars || Object.keys(allCars).length === 0) && restCars) {
        allCars = restCars;
      }
      if ((!locations || Object.keys(locations).length === 0) && restLocations) {
        locations = restLocations;
      }

      if (driversData && typeof driversData === "object") {
        const arr = mapAvailableDrivers(driversData, allCars || {}, locations || {}, settings || {});
        dispatch({
          type: FETCH_ALL_DRIVERS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_ALL_DRIVERS_FAILED,
          payload: "No users available.",
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_ALL_DRIVERS_FAILED,
        payload: error.message,
      });
    }
    return;
  }

  // Mode 'web' : écouteur temps réel pour le tableau de bord administrateur
  const settingsdata = await get(settingsRef).catch(() => null);
  const settings = (settingsdata && settingsdata.val()) || {};

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null,
  });

  onValue(
    driversRef,
    async (snapshot) => {
      if (snapshot.val()) {
        const carsData = await get(firebase.carAddRef).catch(() => null);
        let allCars = (carsData && carsData.val()) || {};
        if (!allCars || Object.keys(allCars).length === 0) {
          allCars = (await restGet("cars")) || {};
        }

        if (allLocationsRef) {
          try {
            off(allLocationsRef);
          } catch (_) {}
          onValue(allLocationsRef, (locres) => {
            const arr = mapAvailableDrivers(snapshot.val(), allCars, locres.val(), settings);
            dispatch({
              type: FETCH_ALL_DRIVERS_SUCCESS,
              payload: arr,
            });
          });
        } else {
          const arr = mapAvailableDrivers(snapshot.val(), allCars, {}, settings);
          dispatch({
            type: FETCH_ALL_DRIVERS_SUCCESS,
            payload: arr,
          });
        }
      } else {
        dispatch({
          type: FETCH_ALL_DRIVERS_FAILED,
          payload: "No users available.",
        });
      }
    },
    (error) => {
      dispatch({
        type: FETCH_ALL_DRIVERS_FAILED,
        payload: error.message,
      });
    }
  );
};

export const fetchAssignableDrivers = () => (dispatch) => {
  const { usersRef, driversRef, carAddRef } = firebase;

  const handleDriversData = async (data, carsOverride) => {
    if (!data) return;
    let allCars = carsOverride || {};
    if (!carsOverride) {
      try {
        if (carAddRef) {
          const carsSnap = await Promise.race([
            get(carAddRef),
            new Promise((resolve) => setTimeout(() => resolve(null), 3000))
          ]);
          allCars = carsSnap ? (carsSnap.val() || {}) : {};
        }
      } catch (e) {
        console.warn("[usersactions] Could not load cars for assignable drivers:", e.message);
      }
      if (!allCars || Object.keys(allCars).length === 0) {
        allCars = (await restGet("cars")) || {};
      }
    }

    const arr = Object.keys(data)
      .filter((i) => data[i] && data[i].usertype === "driver")
      .map((i) => {
        const user = { ...data[i], id: i, uid: i };
        const driverCars = Object.keys(allCars)
          .filter(cid => allCars[cid] && (allCars[cid].driverId === i || allCars[cid].driver === i || allCars[cid].driver_uid === i))
          .map(cid => ({ ...allCars[cid], id: cid }));

        if (driverCars.length > 0) {
          user.cars = driverCars.reduce((acc, car) => {
            acc[car.id] = car;
            return acc;
          }, {});
          const active = driverCars.find(c => c.isAvailable || c.active) || driverCars[0];
          if (active) {
            user.carType = active.carType || user.carType || "";
            user.vehicleNumber = active.vehicleNumber || active.vehiculeNumber || user.vehicleNumber || "";
            user.vehicle_number = user.vehicleNumber;
            user.vehicleMake = active.vehicleMake || user.vehicleMake || "";
            user.vehicleModel = active.vehicleModel || user.vehicleModel || "";
            user.color = active.color || user.color || "";
          }
        }
        return user;
      });

    dispatch({
      type: FETCH_ALL_USERS_SUCCESS,
      payload: arr,
    });
    dispatch({
      type: FETCH_ALL_USERS_STATIC_SUCCESS,
      payload: arr,
    });
    dispatch({
      type: FETCH_ALL_DRIVERS_SUCCESS,
      payload: arr,
    });
  };

  let hasUsersData = false;

  // 0. Authenticated REST load (works even when the SDK websocket is not authenticated)
  (async () => {
    const restCars = (await restGet("cars")) || {};
    let restUsers = await restGet("users");
    if (restUsers && typeof restUsers === "object") {
      hasUsersData = true;
    } else {
      restUsers = await restGet("users", `orderBy=${encodeURIComponent('"usertype"')}&equalTo=${encodeURIComponent('"driver"')}`);
    }
    if (restUsers && typeof restUsers === "object" && Object.keys(restUsers).length > 0) {
      await handleDriversData(restUsers, restCars);
    }
  })();

  // 1. Always attach driversRef (permitted for all authenticated users without root access required)
  if (driversRef) {
    onValue(
      driversRef,
      (snapshot) => {
        if (!hasUsersData && snapshot.val()) {
          handleDriversData(snapshot.val());
        }
      },
      (err) => {
        console.warn("[usersactions] fetchAssignableDrivers driversRef error:", err.message);
      }
    );
  }

  // 2. Also attach usersRef (if admin has root users read permission, this provides all users including admin/fleetadmin)
  if (usersRef) {
    onValue(
      usersRef,
      (snapshot) => {
        if (snapshot.val()) {
          hasUsersData = true;
          handleDriversData(snapshot.val());
        }
      },
      (err) => {
        console.warn("[usersactions] fetchAssignableDrivers usersRef permission fallback to driversRef:", err.message);
      }
    );
  }
};

export const addUser = (userdata) => (dispatch) => {
  const { usersRef } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata,
  });

  delete userdata.tableData;

  push(usersRef, userdata)
    .then(() => {
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: null,
      });
    })
    .catch((error) => {
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error,
      });
    });
};

export const editUser = (id, user) => (dispatch) => {
  const { singleUserRef } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user,
  });

  const editedUser = { ...user };
  delete editedUser.id;
  delete editedUser.tableData;
  delete editedUser.totalBookings;

  Object.keys(editedUser).forEach((key) => {
    if (editedUser[key] === undefined) {
      delete editedUser[key];
    }
  });

  return update(singleUserRef(id), editedUser)
    .then(() => {
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: editedUser,
      });
      return editedUser;
    })
    .catch((error) => {
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error,
      });
      throw error;
    });
};

export const updateUserCar = (id, data) => async (dispatch, getState) => {
  const { singleUserRef } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: data,
  });

  // Update Redux auth.profile and AsyncStorage immediately if updating the logged-in driver's car
  try {
    const state = typeof getState === "function" ? getState() : store.getState();
    const currentProfile = state?.auth?.profile;
    if (currentProfile && currentProfile.uid === id) {
      const updatedProfile = { ...currentProfile, ...data };
      dispatch({
        type: "FETCH_USER_SUCCESS",
        payload: updatedProfile,
      });
      try {
        const AsyncStorage =
          require("@react-native-async-storage/async-storage").default ||
          require("@react-native-async-storage/async-storage");
        if (AsyncStorage) {
          const raw = await AsyncStorage.getItem("driver2go_auth_session");
          if (raw) {
            const session = JSON.parse(raw);
            session.profile = updatedProfile;
            await AsyncStorage.setItem("driver2go_auth_session", JSON.stringify(session));
          }
        }
      } catch (_) {}
    }
  } catch (_) {}

  // Whitelisted driver user fields according to RTDB $usernode security rules
  const coreAllowedKeys = [
    "carType",
    "carTypes",
    "activeCarId",
    "vehicleNumber",
    "vehicleMake",
    "vehicleModel",
    "other_info",
    "car_image",
    "updateAt",
    "updatedAt"
  ];
  const coreData = {};
  const extraData = {};
  Object.keys(data || {}).forEach((k) => {
    if (data[k] !== undefined && k !== "carApproved") {
      if (coreAllowedKeys.includes(k)) {
        coreData[k] = data[k];
      } else {
        extraData[k] = data[k];
      }
    }
  });

  if (singleUserRef) {
    if (Object.keys(coreData).length > 0) {
      update(singleUserRef(id), coreData).catch(() => {});
    }
    if (Object.keys(extraData).length > 0) {
      update(singleUserRef(id), extraData).catch(() => {});
    }
  }

  try {
    const { getValidAuthToken } = require("./authactions");
    let token = await getValidAuthToken();
    if (token && id) {
      const base = getRtdbRestBase();
      if (Object.keys(coreData).length > 0) {
        let res = await fetch(`${base}/users/${id}.json?auth=${token}`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(coreData),
        });
        if (res.status === 401 || res.status === 403) {
          token = await getValidAuthToken(true);
          if (token) {
            await fetch(`${base}/users/${id}.json?auth=${token}`, {
              method: "PATCH",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(coreData),
            });
          }
        }
      }
      if (Object.keys(extraData).length > 0 && token) {
        fetch(`${base}/users/${id}.json?auth=${token}`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(extraData),
        }).catch(() => {});
      }
    }
  } catch (_) {}
};

export const updateLicenseImage =
  (uid, imageBlob, imageType) => async (dispatch) => {
    const {
      singleUserRef,
      driverDocsRef,
      driverDocsRefBack,
      verifyIdImageRef,
    } = firebase;

    let profile = {};
    if (imageType === "licenseImage") {
      await uploadBytesResumable(driverDocsRef(uid), imageBlob);
      let image = await getDownloadURL(driverDocsRef(uid));
      profile.licenseImage = image;
    }
    if (imageType === "licenseImageBack") {
      await uploadBytesResumable(driverDocsRefBack(uid), imageBlob);
      let image1 = await getDownloadURL(driverDocsRefBack(uid));
      profile.licenseImageBack = image1;
    }
    if (imageType === "verifyIdImage") {
      await uploadBytesResumable(verifyIdImageRef(uid), imageBlob);
      let image1 = await getDownloadURL(verifyIdImageRef(uid));
      profile.verifyIdImage = image1;
    }
    update(singleUserRef(uid), profile);
    dispatch({
      type: EDIT_USER,
      payload: uid,
    });
  };

export const deleteUser = (uid) => async (dispatch) => {
  const {
    auth,
    config,
    walletHistoryRef,
    singleUserRef,
    userNotificationsRef,
    signOut,
  } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: uid,
  });

  let sessionUid = null;
  let AsyncStorage = null;
  try {
    AsyncStorage = require('@react-native-async-storage/async-storage').default || require('@react-native-async-storage/async-storage');
  } catch (_) {}
  if (AsyncStorage) {
    try {
      const raw = await AsyncStorage.getItem('driver2go_auth_session');
      if (raw) {
        const parsed = JSON.parse(raw);
        sessionUid = parsed?.uid || parsed?.user?.uid;
      }
    } catch (_) {}
  }

  const currentUid = auth?.currentUser?.uid || sessionUid;
  const targetUid = uid || currentUid;
  const isSelf = !uid || uid === currentUid;

  try {
    const isLocal = typeof window !== 'undefined' && window.location && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    const origin = (typeof window !== 'undefined' && window.location && !isLocal) ? window.location.origin : null;
    const functionsUrl = (typeof process !== 'undefined' && process.env?.REACT_APP_FUNCTIONS_URL)
      ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '')
      : null;
    const activeProjectId = config?.projectId || firebase.config?.projectId || "drive2go-c806b";
    const region = (typeof process !== "undefined" && (process.env?.REACT_APP_FUNCTIONS_REGION || process.env?.FUNCTIONS_REGION)) || firebase.config?.functionsRegion || "europe-west1";
    let host = functionsUrl || origin || `https://${region}-${activeProjectId}.cloudfunctions.net`;
    let url = `${host}/delete_user_account`;

    let idToken = null;
    try {
      const { getValidAuthToken } = require("./authactions");
      if (typeof getValidAuthToken === 'function') {
        idToken = await getValidAuthToken();
        if (!idToken) {
          idToken = await getValidAuthToken(true);
        }
      }
    } catch (_) {}

    if (!idToken && auth?.currentUser && typeof auth.currentUser.getIdToken === 'function') {
      try {
        idToken = await auth.currentUser.getIdToken();
      } catch (_) {}
    }

    const headers = { 'Content-Type': 'application/json' };
    if (idToken) headers['Authorization'] = `Bearer ${idToken}`;

    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify({ uid: targetUid }),
    });

    let result = {};
    try {
      result = await response.json();
    } catch (_) {}

    if (!response.ok || !result?.success) {
      const isAlreadyDeleted = isSelf && (
        response.status === 401 ||
        result?.error === 'UNAUTHORIZED' ||
        result?.error === 'USER_NOT_FOUND' ||
        (result?.message && (result.message.toLowerCase().includes('token') || result.message.toLowerCase().includes('not found') || result.message.toLowerCase().includes('expired')))
      );

      if (!isAlreadyDeleted) {
        dispatch({
          type: DELETE_USER_FAILED,
          payload: result?.error || 'DELETE_FAILED',
        });
        return {
          success: false,
          error: result?.error || 'DELETE_FAILED',
          message: result?.message,
        };
      } else {
        console.warn("[deleteUser] Account was already deleted on server. Proceeding with clean session tear down.");
      }
    }

    if (isSelf) {
      try {
        off(singleUserRef(targetUid));
        off(walletHistoryRef(targetUid));
        off(userNotificationsRef(targetUid));
      } catch (_) {}

      try {
        if (AsyncStorage) {
          await AsyncStorage.removeItem('driver2go_auth_session').catch(() => {});
        }
      } catch (_) {}

      try {
        const { getNativeAuthModule } = require("./authactions");
        const nativeAuthFn = getNativeAuthModule ? getNativeAuthModule() : null;
        if (nativeAuthFn && typeof nativeAuthFn.signOut === 'function') {
          await nativeAuthFn.signOut().catch(() => {});
        }
      } catch (_) {}

      try {
        await signOut(auth);
      } catch (_) {}

      dispatch({
        type: USER_DELETED,
        payload: null,
      });
    } else {
      dispatch({
        type: DELETE_USER_SUCCESS,
        payload: targetUid,
      });
    }

    return { success: true };
  } catch (error) {
    console.error("deleteUser error:", error);
    dispatch({
      type: DELETE_USER_FAILED,
      payload: error.message || error,
    });
    return {
      success: false,
      error: error.message || 'NETWORK_ERROR',
    };
  }
};
